<script>
  $("#myCarousel").carousel({
    interval: false,
  });
</script>
<header id="navigation" class="header navbar navbar-dark navbar-fixed-top">
  <div class="row w-100">
    <div class="col-lg-9 w-100"></div>
    <div class="col-lg-3 col-xl-3 col-md-3 pr-0">
      <div
        class="container header__container d-md-flex d-xl-inline d-lg-flex pr-0"
        style="justify-content: flex-end"
      >
        <div class="header__menu">
          <nav id="navbar" class="header__nav collapse stroke">
            <div class="flex-container">
              <div
                class="d-flex"
                style="justify-content: center !important; width: 79px"
              >
                <!-- <img src="assets/icons/head-alarm.svg" /> -->
                <img
                  src="assets/icons/avatar.svg"
                  style="width: 35px !important"
                />
              </div>
              <p style="margin-top: 15px; margin-left: 15px">
                {{ userFromApi.username }}
              </p>
              <img
                src="assets/icons/v.svg"
                style="margin-left: 10px !important"
                (click)="showDiv()"
              />
            </div>
          </nav>
        </div>
        <div
          *ngIf="show"
          (click)="logout()"
          class="d-flex"
          style="
            justify-content: space-between !important;
            margin-top: 50px !important;
            border-radius: 1px black !important;
          "
        >
          <i class="fa fa-power-off" style="margin-left: 300px !important"></i>
          <p style="cursor: pointer">Se déconnecter</p>
        </div>
      </div>
    </div>
  </div>
</header>
